const WAIT_AFTER_SELECTION = 300;

export const FormerConstants = {
  WAIT_AFTER_SELECTION,
};
